import React from 'react'
import Options from './Options'
import loader from '../../../../assets/img/loader.svg'
import NoDataFound from '../../../partials/NoDataFound'
import { trans } from '@/_providers/Translation'

function Table(props) {

    return (

        props.loading
            ?
            <img src={loader} alt="loading" />
            :
            props.suppliers.length === 0
                ?
                <NoDataFound />
                :
                <>
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }}>ID</th>
                                    <th>{trans('tables.name')}</th>
                                    <th>{trans('tables.website')}</th>
                                    <th>{trans('tables.email')}</th>
                                    <th>{trans('tables.phone')}</th>
                                    <th className="options">{trans('tables.options')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.suppliers.map(supplier =>
                                    <tr key={'supplier-' + supplier.id}>
                                        <td style={{ width: '50px' }}>{supplier.id}</td>
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                {supplier.logo_url ?
                                                    <img src={supplier.logo_url} alt=""
                                                        style={{ width: 25, height: 25, borderRadius: 50, objectFit: 'cover', marginRight: 5 }}
                                                    />
                                                    : <div style={{ width: 25, height: 25, borderRadius: 50, objectFit: 'cover', marginRight: 5, backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, color: '#999' }}>
                                                        {supplier.name.charAt(0).toUpperCase()}
                                                    </div>
                                                }
                                                {supplier.name}
                                            </div>
                                        </td>
                                        <td>{supplier.website}</td>
                                        <td>{supplier.email}</td>
                                        <td>{`${supplier.phone_country_code}${supplier.phone_number}`}</td>
                                        <td>
                                            <Options
                                                id={supplier.id}
                                                handleEdit={props.handleEdit}
                                                handleDelete={props.handleDelete}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
    )
}

export default Table